import {useState} from 'react';

// A local copy of a stored value, for fields that save on blur or on an Apply
// button. It starts again from the stored value whenever that changes (another
// object selected, or an edit from elsewhere), so one object's edits can never
// be saved onto another. Compared by content, as merges change stored arrays
// and objects in place.
export default function useDraft<T>(value: T): [T, (draft: T) => void] {
    const valueKey = JSON.stringify(value ?? null);
    const [state, setState] = useState({valueKey, draft: value});

    if (state.valueKey !== valueKey) {
        setState({valueKey, draft: value});
    }

    return [
        state.valueKey === valueKey ? state.draft : value,
        draft => setState({valueKey, draft})
    ];
}
